<script lang="ts">
  import { page } from '$app/stores';
  import { storeHeroMenu } from '$lib/js/stores'
  import type { Category } from "$lib/js/elasticsearch/types";
	import { getUniverseInfo } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let firstLevel: Category[]
  export let secondLevel: Category[]
  export let thirdLevel: Category[]

	const scope = getContextScope()

  let firstActive = firstLevel[0].id
  let secondActive = secondLevel[0].id
  let current = 0

  $: displayThird = 'not-visible'

  function closeMenu() {
    $storeHeroMenu = ''
  }

  function optionFirstHovered(option_id: number) {
    firstActive = option_id
    displayThird = 'not-visible'
  }

  function optionSecondHovered(option_id: number) {
    secondActive = option_id
    displayThird = 'visible'
  }

  $: universe_info = getUniverseInfo(
    $page.data?.universes_menu?.universes,
    $page.data?.category?.url_path?.split("/")[1]
  )

  $: if (universe_info && $page.data.category) {
    firstActive = parseInt(universe_info.cat_id, 10)
    current = parseInt($page.data.category.path.split("/")[3], 10)
    secondActive = current
    displayThird = 'visible'
  }
</script>


<div class="hero-menu__inner">
  {#if !universe_info && ($page.route.id !== "/[lang]/p/[prod_url]" && $page.route.id !== "/[lang]/c/[...cat_url]")}
    <div class="hero-menu__primary">
      {#each firstLevel as option}
        <a
          role="menuitem"
          class:selected={current === option.id}
          href="/{scope}/{option.url_path}"
          on:mouseenter={() => optionFirstHovered(option.id)}
          on:click={() => closeMenu()}
        >{option.name}</a>
      {/each}
    </div>
  {/if}

  <div class="hero-menu__secondary">
    {#each secondLevel as option}
      {#if option.parent_id === firstActive}
        <a
          role="menuitem"
          class:selected={secondActive === option.id}
          class:current={current === option.id}
          href="/{scope}/{(option.url_path)}"
          on:mouseenter={() => optionSecondHovered(option.id)}
          on:click={() => closeMenu()}
        >{option.name}</a>
      {/if}
    {/each}
  </div>

  <div class="hero-menu__tertiary {displayThird}">
    {#each thirdLevel as option}
      {#if option.parent_id === secondActive}
        <a
          role="menuitem"
          href="/{scope}/{option.url_path}"
          on:click={() => closeMenu()}
        >{option.name}</a>
      {/if}
    {/each}
  </div>
</div>


<style lang="scss">
  .hero-menu {
    &__inner {
      max-height: calc(100vh - 300px);
      display: flex;
      transition: all linear 0.25s;
      margin-top: 25px;
    }

    &__primary,
    &__secondary,
    &__tertiary {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 250px;
      overflow-y: scroll;

      a {
        color: black;
        padding: 8px 15px;

        &.current {
          background: #939393;
          color: white;
        }

        &:hover {
          color: var(--main);
        }

        &.selected {
          background: var(--main);
          color: white;
        }
      }
    }

    &__secondary {
      background: var(--grey);
    }

    &__tertiary {
      transition: all linear 0.125s;
      max-width: 100%;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      height: 100%;
      overflow-y: scroll;
      max-height: calc(100vh - 300px);

      @media (min-width: 1330px) {
        overflow-y: hidden;
      }

      @media (min-width: 1330px) and (max-width: 1595px) {
        max-height: calc(100vh - 190px);
      }

      &.not-visible {
        visibility: hidden;
        opacity: 0;
      }

      &.visible {
        visibility: visible;
        opacity: 1;
      }

      a {
        padding: 5px 15px;
        width: 250px;
      }
    }
  }
</style>
